export * from '@primeuix/themes/aura/card';
export { default } from '@primeuix/themes/aura/card';
